/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const usePgHbaStyles = makeStyles(() => ({
  header: {
    maxWidth: '840px',
    borderBottom: '2px solid #EEEEEE',
  },
  headerItem: {
    padding: '0 10px 15px',
    fontSize: '12px',
    lineHeight: '15px',
    textTransform: 'uppercase',
    borderWidth: '2px',
  },
}));
